import React from "react";
import { Empty } from "antd";

export default function CustomerLeaderboard() {
  return <section className="member-leaderboard" aria-label="Bảng xếp hạng">
    <h2>Bảng xếp hạng <span>Giọng ca Muzic Box</span></h2>
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Bảng xếp hạng chưa được công bố. Hãy quay lại sau nhé!" />
  </section>;
}
